import { createRoot } from "react-dom/client";
import './i18n/i18n';
import App from "./App.tsx";
import "./index.css";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById("splash");
    if (splash) {
      splash.style.transition = "opacity 0.4s ease-out";
      splash.style.opacity = "0";
      setTimeout(() => splash.remove(), 400);
    }
  });
});
